export function resolveProxyUrl({
  envProxyUrl,
  nodeEnv,
  windowOrigin,
} = {}) {
  if (envProxyUrl) {
    return envProxyUrl;
  }

  if (nodeEnv === 'development') {
    return 'http://localhost:8000';
  }

  if (windowOrigin) {
    return windowOrigin;
  }

  return 'http://localhost:8000';
}
